export default __webpack_public_path__ + "static/media/slider5en.bc8f247d.jpg";